import { render } from "./ui-tags.vue?vue&type=template&id=7ba16bf8&scoped=true&ts=true"
import script from "./ui-tags.vue?vue&type=script&lang=ts"
export * from "./ui-tags.vue?vue&type=script&lang=ts"

import "./ui-tags.vue?vue&type=style&index=0&id=7ba16bf8&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba16bf8"]])

export default __exports__